<template>
  <div>
    <v-dialog
      v-model="tradesLoading"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="fullscreen"
    >
      <loadingScreen />
    </v-dialog>
    <div class="main-container">
      <!-- <v-btn @click="toggleAddTradeModal({ show: true, type: 'add' })"
        >trade</v-btn
      > -->
      <div class="d-flex flex-column flex-md-row">
        <trade-detail-form
          v-if="trade_detail_form.flag"
          :trade_detail_form="trade_detail_form"
        />
        <reviewand-post-trade
          @trade-edit="tradeEdit"
          @share-trade="shareTrade"
          @reloadTrades="reloadTrades"
          v-if="trade_review_data.flag"
        />
        <TradeForm @trade-review="reviewTrade" />
        <div class="px-5 px-md-8 py-6 scrollable child-1 flex-grow-1">
          <div
            class="d-flex justify-space-between align-baseline mb-4"
            v-if="showGroupsHeader"
          >
            <h3 v-if="$featureFlags.groups" class="">Groups You Follow</h3>
            <div>
              <div @click="openViewAll()" class="view-all-groups">View all</div>
            </div>
            <!-- <group-create-btn></group-create-btn> -->
          </div>

          <group-row class="" v-if="$featureFlags.groups"></group-row>
          <pollCard class="mb-4" />
          <!-- <v-divider class="my-4"></v-divider> -->
          <h3
            v-if="$featureFlags.groups"
            :class="trades.length == 0 ? 'd-none d-md-block' : 'mb-4'"
          >
            Feed
          </h3>
          <v-col sm="12" md="12" class="mb-4">
            <!-- <TradeCard> </TradeCard> -->
          </v-col>

          <div
            class="sort-and-filter d-flex align-center justify-center"
            v-if="!tradesLoading"
          >
            <v-select
              @change="filterTrades"
              v-model="status"
              item-text="name"
              item-value="value"
              multiple
              :items="statusItems"
              dense
              label="Status"
              outlined
              class="selectBox"
              background-color="#fff"
            ></v-select>
            <v-select
              @change="filterTrades"
              v-model="buy_sell"
              multiple
              :items="buysellItems"
              dense
              label="Buy/Sell"
              outlined
              class="selectBox"
              background-color="#fff"
            ></v-select>

            <v-select
              @change="filterTrades"
              v-model="duration"
              multiple
              item-text="name_to_show"
              item-value="id"
              :items="durationItems"
              dense
              label="Duration"
              outlined
              class="selectBox"
              background-color="#fff"
            ></v-select>
            <v-spacer></v-spacer>
            <v-menu
              offset-y
              bottom
              v-if="userDetail.profile.is_sebi_registered"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  height="40"
                  color="#2d8cff"
                  class="mb-4 add-trade-button"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="#fff">mdi-plus</v-icon> Add New
                </v-btn>
              </template>

              <v-list>
                <v-list-item @click="addTrade">
                  <v-list-item-title>Add New Trade</v-list-item-title>
                </v-list-item>

                <v-list-item @click="openPollDialog">
                  <v-list-item-title>Add New Poll</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              v-else
              @click="addTrade()"
              height="40"
              color="#2d8cff"
              class="mb-4 add-trade-button"
              ><v-icon color="#fff">mdi-plus</v-icon> Add new trade</v-btn
            >
          </div>
          <div :class="trades.length == 0 ? 'd-none d-md-block' : 'mt-8'">
            <div
              v-if="trades.length == 0 && !tradesLoading"
              class="no-content-div text-center d-flex flex-column"
            >
              <img
                :src="home_page_no_data_illustation"
                height="300"
                width="300"
                alt=""
                class="mx-auto mt-10"
              />
              <p class="ma-10">
                Oops! No posts here. Follow experts to see their posts.
              </p>
              <v-btn
                @click="addTrade()"
                width="150"
                height="40"
                color="#2d8cff"
                class="mt-4 mx-auto add-trade-button"
                ><v-icon color="#fff">mdi-plus</v-icon> Add new trade
              </v-btn>
            </div>

            <div v-if="tradesLoading" class="card-container">
              <v-skeleton-loader
                v-for="item in 5"
                :key="item"
                class="mt-2 pa-2"
                type="card-avatar, sentences ,actions"
              ></v-skeleton-loader>
            </div>
            <div class="card-container" v-if="!tradesLoading">
              <!-- <TradeCard
                class="mb-8"
                :key="dummy_trade_data[0].id"
                :trade_data="dummy_trade_data[0]"
                :ref="`${dummy_trade_data[0].id}`"
              >
              </TradeCard>
              <TradeCard
                class="mb-8"
                :key="dummy_trade_data[1].id"
                :trade_data="dummy_trade_data[1]"
                :ref="`${dummy_trade_data[1].id}`"
              >
              </TradeCard> -->
              <!-- <TradeCard
                class="mb-8"
                :key="dummy_trade_data[1].id"
                :trade_data="dummy_trade_data[1]"
                :ref="`${dummy_trade_data[1].id}`"
              >
              </TradeCard>
              <TradeCard
                class="mb-8"
                :key="dummy_trade_data[2].id"
                :trade_data="dummy_trade_data[2]"
                :ref="`${dummy_trade_data[2].id}`"
              >
              </TradeCard> -->

              <!-- new Trade card -->
              <div class="mb-8" v-for="item in trades" :key="item.id">
                <!-- v-for="item in trades"
                :key="item.id" -->
                <TradeCard
                  v-if="item.is_equity_trade"
                  :trade_data="item"
                  :ref="`${item.id}`"
                >
                </TradeCard>

                <!-- F&O Trade card -->

                <FOTradecard
                  v-else
                  :trade_data="item"
                  :ref="`${item.id}`"
                  class=""
                >
                </FOTradecard>
              </div>

              <!-- <trade-user-data
                :showDivider="true"
                @reload-trending-trades="reloadTrades"
                @reload-home-trades="reloadTrades"
                @home-reload="reloadTrades"
                @reloadTradesHome="reloadTrades"
                class="mb-4"
                :home="true"
                :show_button="false"
                :trade_data="item"
                :show_more="true"
                :is_user_content="true"
                v-for="item in trades"
                :key="item.id"
                :ref="`${item.id}`"
              /> -->
              <div class="text-center" v-if="hide" v-intersect="onIntersect">
                <v-progress-circular
                  indeterminate
                  color="#2f80ed"
                ></v-progress-circular>
                Loading More...
              </div>
            </div>
          </div>
        </div>
        <div class="child-2 py-6 px-6 scrollable">
          <p>Recommendations</p>
          <div v-if="profilesLoading" class="card-container">
            <v-skeleton-loader
              v-for="item in 5"
              :key="item.id"
              class="pa-2"
              type="list-item-avatar-three-line"
            ></v-skeleton-loader>
          </div>
          <div v-if="!profilesLoading.length">
            <profile-card-component
              :profile_object="item"
              v-for="item in influencers_list"
              :key="item.id"
              @reload-home-profile="getInfluencersList"
              class="mt-4"
            />
            <div
              class="text-center"
              v-if="
                !influencerHide &&
                influencerNumPages > 1 &&
                influencerPage !== influencerNumPages
              "
              v-intersect="onInfluencerIntersect"
            >
              <v-progress-circular
                indeterminate
                color="#2f80ed"
              ></v-progress-circular>
              Loading More...
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-btn
      color="#2D8CFF"
      dark
      class="mb-4 floatingIcon text-capitalize"
      fixed
      bottom
      right
      absolute
      fab
      @click="addTrade()"
    >
      <v-icon>mdi-plus</v-icon>
      <span>Add Trade</span>
    </v-btn> -->
    <!-- <v-btn
        color="#2D8CFF"
        dark
        class="mb-4 floatingIcon text-capitalize elevation-4"
        fixed
        rounded
        inner-height="44"
        style="position:sticky;"
        bottom
        right
        @click="addTrade()"
      >
        <v-icon small>mdi-plus</v-icon>
        <span
        style="font-weight:800;letter-spacing:0px;"
        
        >Add Trade</span>
      </v-btn> -->
    <v-fab-transition class="floatingIcon elevation-10">
      <v-btn
        color="#2D8CFF"
        dark
        class="mb-15 floatingIcon text-capitalize elevation-10"
        fixed
        rounded
        inner-height="44"
        bottom
        right
        relative
        style="z-index: 4"
        @click="addTrade()"
      >
        <v-icon small>mdi-plus</v-icon>
        <span style="font-weight: 800; letter-spacing: 0px">Add Trade</span>
      </v-btn>
    </v-fab-transition>
    <uploadPollDialog />
  </div>
</template>

<script>
import Axios from "@/api/BaseAxios.js";
import ProfileCardComponent from "@/components/Profile/ProfileCardComponent.vue";
// import GroupCreateBtn from "./GroupCreateBtn.vue";

// import TradeUserData from "@/components/Trade/TradeUserData.vue";
// import { isAuthenticated } from "../../common/commonFunctions";
import TradeDetailForm from "@/components/Trade/TradeDetailForm.vue";
import TradeForm from "@/components/Trade/TradeForm.vue";
import ReviewandPostTrade from "@/components/Trade/ReviewandPostTrade.vue";
import GroupRow from "@/components/GroupRow.vue";
import { mapActions } from "vuex";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import helper from "@/helper/index.js";
import TradeCard from "@/components/TradeCard.vue";
import FOTradecard from "@/components/F&OTradecards.vue";
// import GroupCreateBtn from "@/components/GroupCreateBtn.vue";

// import StepProgress from "vue-step-progress";
// import stepper from "@/components/Stepper.vue";
import loadingScreen from "@/components/LoadingScreen";
import pollCard from "@/components/Home/PollSection/pollCard.vue";
import uploadPollDialog from "@/components/Home/PollSection/UploadPollDialog.vue";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "HomePage",
  components: {
    "profile-card-component": ProfileCardComponent,
    // "trade-user-data": TradeUserData,
    TradeForm,
    TradeDetailForm,
    ReviewandPostTrade,
    GroupRow,
    TradeCard,
    FOTradecard,
    // GroupCreateBtn,
    // StepProgress,
    loadingScreen,
    pollCard,
    uploadPollDialog,
  },
  metaInfo: {
    title: "Home",
  },
  // provide() {
  //   return {
  //     trade_data: this.item,
  //     ref: this.item.id,
  //   };
  // },
  data: () => ({
    // dummy_trade_data: [
    //   {
    //     id: 1050,
    //     yof: 0,
    //     security: 981,
    //     duration: 1,
    //     posted_by: 681,
    //     status: "Active",
    //     trade_type: "Buy",
    //     exit_price: 0.0,
    //     pl_data: "1.65",
    //     pl_percent: "10.09",
    //     entry_price: 16.35,
    //     target_price: 18.0,
    //     profit_percent: "-4.94",
    //     price_up_down: "-0.85",
    //     live_price: "15",
    //     stop_loss: 15.0,
    //     user_image: null,
    //     posted_time: "16 hours",
    //     current_loss: 0.0,
    //     current_profit: 0.0,
    //     duration_name: "Intra-day/BTST ",
    //     security_name: "JHS Svendgaard Laboratories Limited",
    //     security_symbol: "JHS",
    //     security_exchange: "NSE",
    //     posted_by_name: "Aakash Sahu",
    //     reasoning: {
    //       id: 1057,
    //       content: null,
    //       posted_date: "26 March, 2024",
    //     },
    //     is_sebi_registered: false,
    //     target_return_percent: 0.0,
    //     posted_by_id: 699,
    //     is_following_user: true,
    //     is_follower: false,
    //     is_follower_security: false,
    //     followers_count: 0,
    //     comments_count: 0,
    //     created: "2024-03-26T16:43:33.409363",
    //     modified: "2024-03-26T16:43:35.004905",
    //     posted_by_group: null,
    //     visibility: "all",
    //     duration_type: [
    //       {
    //         name: "Intra-day/BTST (1~2 days)",
    //         id: 1,
    //         name_to_show: "Intra-day",
    //       },
    //       {
    //         name: "Swing (2~6 weeks)",
    //         id: 3,
    //         name_to_show: "Swing",
    //       },
    //       {
    //         name: "Long term (>6 weeks)",
    //         id: 4,
    //         name_to_show: "Long term",
    //       },
    //     ],
    //     target_stop_loss_list: [
    //       {
    //         id: 947,
    //         target_price: 18.0,
    //         stop_loss: 15.0,
    //       },
    //     ],
    //     first_stop_loss: 15,
    //     final_target: 18.0,
    //     trade_live_time: null,
    //     trade_closing_time: null,
    //     lots: 1,
    //     copy_origin: null,
    //     copy_origin_name: null,
    //     copy_origin_id: null,
    //     order_type: "",
    //     slm_price: 0.0,
    //     slm_target_price: 0.0,
    //     opt_notification: true,
    //     security_logo:
    //       "https://api.staging.covesto.in/media/security/logo/JHS_nHxuxJp.png",
    //     is_trade_private: false,
    //     trade_exit_type: false,
    //     security_ltp: 16.35,
    //     is_trade_saved: false,
    //     is_security_saved: false,
    //   },
    //   {
    //     id: 1003,
    //     yof: 0,
    //     security: 399,
    //     duration: 1,
    //     posted_by: 648,
    //     status: "Active",
    //     trade_type: "Buy",
    //     exit_price: 0.0,
    //     pl_data: "3.00",
    //     pl_percent: "0.33",
    //     entry_price: 897.0,
    //     target_price: 900.0,
    //     profit_percent: "-1.68",
    //     price_up_down: "-14.95",
    //     live_price: "900",
    //     stop_loss: 800.0,
    //     user_image:
    //       "https://api.staging.covesto.in/media/profile_images/4c192a03-aa40-4ac0-8cc0-4de0e0936e49.jpeg",
    //     posted_time: "11 days",
    //     current_loss: 0.0,
    //     current_profit: 0.0,
    //     duration_name: "Intra-day/BTST ",
    //     security_name: "Cochin Shipyard Limited",
    //     security_symbol: "COCHINSHIP",
    //     security_exchange: "NSE",
    //     posted_by_name: "Sagar Patel Official",
    //     reasoning: {
    //       id: 1010,
    //       content: null,
    //       posted_date: "16 March, 2024",
    //     },
    //     is_sebi_registered: true,
    //     target_return_percent: 0.0,
    //     posted_by_id: 665,
    //     is_following_user: false,
    //     is_follower: false,
    //     is_follower_security: false,
    //     followers_count: 0,
    //     comments_count: 0,
    //     created: "2024-03-16T14:33:51.803921",
    //     modified: "2024-03-18T16:04:31.321810",
    //     posted_by_group: null,
    //     visibility: "all",
    //     duration_type: [
    //       {
    //         name: "Intra-day/BTST (1~2 days)",
    //         id: 1,
    //         name_to_show: "Intra-day",
    //       },
    //       {
    //         name: "Swing (2~6 weeks)",
    //         id: 3,
    //         name_to_show: "Swing",
    //       },
    //       {
    //         name: "Long term (>6 weeks)",
    //         id: 4,
    //         name_to_show: "Long term",
    //       },
    //     ],
    //     target_stop_loss_list: [
    //       {
    //         id: 891,
    //         target_price: 900.0,
    //         stop_loss: 800.0,
    //       },
    //       {
    //         id: 892,
    //         target_price: 1000.0,
    //         stop_loss: 897.0,
    //       },
    //     ],
    //     first_stop_loss: 800.0,
    //     final_target: 1000.0,
    //     trade_live_time: null,
    //     trade_closing_time: null,
    //     lots: 1,
    //     copy_origin: null,
    //     copy_origin_name: null,
    //     copy_origin_id: null,
    //     order_type: "",
    //     slm_price: 0.0,
    //     slm_target_price: 0.0,
    //     opt_notification: true,
    //     security_logo:
    //       "https://api.staging.covesto.in/media/security/logo/QuerySet_SecurityData_AAA_TECHNOLOGIES_L_SecurityData_3rd_Rock_Multimedia__egEW5AF.png",
    //     is_trade_private: false,
    //     trade_exit_type: false,
    //     security_ltp: 897.0,
    //     is_trade_saved: false,
    //     is_security_saved: false,
    //     reasonings: [
    //       {
    //         id: 1010,
    //         content: null,
    //         posted_date: "16 March, 2024",
    //       },
    //     ],
    //     comments: [],
    //     followers: [],
    //     posted_by_followers: [588, 608, 601, 612],
    //     posted_by_following: [
    //       503, 181, 408, 283, 484, 52, 398, 309, 416, 173, 596, 135, 390, 454,
    //       537, 23, 25, 389, 40, 681, 575, 7, 588, 608, 397, 612,
    //     ],
    //     latest_reasoning: [
    //       {
    //         id: 1010,
    //         content: null,
    //         posted_date: "16 March, 2024",
    //       },
    //     ],
    //     closing_live_price: 0.0,
    //     is_real: false,
    //     is_featured: false,
    //     is_added_to_watchlist: false,
    //     watchlist_id: false,
    //   },
    // ],
    helper: helper,
    tradesLoading: false,
    profilesLoading: false,
    influencers_list: [],
    el: 1,
    statusItems: [
      { name: "Live", value: "Active" },
      { name: "Upcoming", value: "Inactive" },
    ],
    buysellItems: ["Buy", "Sell"],
    sortItems: ["By Security (A To Z)"],
    durationItems: [
      // { name: "Intra-day", value: "Intra-day-BTST (1~2 days)" },
      // { name: "Short-term", value: "Short term (1~2 weeks)" },
      // { name: "Swing", value: "Intermediate (2~6 weeks)" },
      // { name: "Long-term", value: "Long term (>6 weeks)" },
    ],
    duration: null,
    status: null,
    buy_sell: null,
    sorts: [],
    page: 1,
    numPages: 1,
    influencerPage: 1,
    influencerNumPages: 1,
    trades: [],
    hide: true,
    influencerHide: false,
    is_Intersecting: false,
    home_page_no_data_illustation: require("../../assets/images/home_page_no_data_illustation.png"),

    trade_form_data: {
      flag: false,
      id: null,
      trade_data: {},
      trade_edit: false,
    },
    trade_detail_form: {
      flag: false,
      id: null,
    },
    trade_review_data: {
      flag: false,
      trade_data: {},
    },
    socket: null,
    trade_ids: [],
    security_ids: [],
    userDetail: [],
    // for tradecard section
  }),
  computed: {
    showGroupsHeader() {
      return (
        this.$store.state.groups.updates &&
        this.$store.state.groups.updates.length > 0
      );
    },
  },

  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
      toggleSuperUser: "user/toggleSuperUser",
    }),
    openViewAll() {
      this.$router.push({
        name: "allGroups",
        params: {
          id: this.$route.params.id,
        },
        query: {
          isFromHomePage: "true",
        },
      });
    },
    getUserDetail() {
      const onSuccess = (res) => {
        console.log(res, "kk");
        this.userDetail = res.data.user_detail;
      };
      const onFailure = () => {};
      let params = {};
      params["id"] = commonFunctions.getUserId();
      newAxios("get", apiUrl.ADMIN_PANEL_APIS, {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
    getTradesList(item) {
      const successHandler = (res) => {
        if (item == "append") {
          res.data.result.forEach((item) => {
            this.trades.push(item);
            this.trade_ids.push(item.id);
            this.security_ids.push(item.security);
          });
          this.numPages = res.data.num;
          this.tradesLoading = false;
        } else {
          this.trades = res.data.result;
          this.tradesLoading = false;
          this.numPages = res.data.num;
          for (const item of this.trades) {
            this.trade_ids.push(item.id);
            this.security_ids.push(item.security);
          }
        }
        this.initializeWebSocket();
      };
      const user_id = localStorage.getItem("user_id");
      const errorHandler = (err) => {
        console.log(err);
      };
      const finallyHandler = () => {};
      Axios.request_GET(
        `api/trade/all-trade-list/${user_id}/${this.page}/${
          this.status == "" ? null : this.status
        }/${this.buy_sell == "" ? null : this.buy_sell}/${
          this.duration == "" ? null : this.duration
        }`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        true,
        finallyHandler
      );
    },
    filterTrades() {
      this.page = 1;
      this.getTradesList();
    },
    reloadTrades() {
      this.page = 1;
      this.getTradesList();
    },
    getInfluencersList(item) {
      const successHandler = (res) => {
        if (item == "append") {
          res.data.result.forEach((i) => {
            this.influencers_list.push(i);
          });
          this.influencerNumPages = res.data.num;
          this.profilesLoading = false;
        } else {
          this.influencers_list = res.data.result;
          this.influencerNumPages = res.data.num;
          this.profilesLoading = false;
        }
      };
      const errorHandler = () => {};
      const user_id = localStorage.getItem("user_id");
      Axios.request_GET(
        `api/influencers-list/${user_id}/${this.influencerPage}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    onIntersect(entries) {
      this.hide = true;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.page += 1;
          if (this.page <= this.numPages) {
            this.getTradesList("append");
          } else {
            this.hide = false;
          }
        }
      });
    },
    onInfluencerIntersect(entries) {
      this.influencerHide = false;
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.influencerPage += 1;
          if (this.influencerPage <= this.influencerNumPages) {
            this.getInfluencersList("append");
          } else {
            this.influencerHide = true;
          }
        }
      });
    },
    addTrade() {
      this.$logEvent("add_trade_home_page");
      this.trade_form_data.flag = true;
      // this.toggleTradeModal({ show: true, type: "add" });
      this.toggleAddTradeModal({ show: true, type: "add" });
    },
    openPollDialog() {
      this.$store.commit("poll/togglePollModal", { show: true });
    },
    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },
    tradeEdit(data) {
      this.trade_form_data.trade_data = data;
      this.trade_form_data.trade_edit = true;
      this.trade_form_data.flag = true;
    },
    shareTrade(data) {
      navigator.share(
        {
          title: "Covesto",
          text: `Hello, ${data.posted_by_name} has shared a trade recommendation on Covesto.${data.trade_type} ${data.security_name}
            To know more details and get live updates, follow the trade at `,
          url: `https://covesto.in/trade/${data.id}/${data.security.name}`,
        },
        {
          skype: false,
          pinterest: false,
          print: false,
          sms: false,
        }
      );
      this.getTradeList(0);
    },
    isSuperUser() {
      this.loading = true;
      const successHandler = (res) => {
        let eligible = res.data.is_superuser;
        localStorage.setItem("is_superuser", eligible);
        this.toggleSuperUser({ super_user: eligible });
      };
      const failureHandler = () => {};

      let formData = {};
      Axios.request_GET(
        "/api/super-user/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    initializeWebSocket() {
      const socketUrl = process.env.VUE_APP_WEBSOCKET_URL;
      this.socket = new WebSocket(socketUrl);

      this.socket.onopen = () => {
        console.log("WebSocket connection established.");
        const data = {
          type: "security",
          id: this.security_ids,
        };
        this.socket.send(JSON.stringify(data));
        // console.log(data, "data");
      };
      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        const { pk, fields } = data;
        if (this.security_ids.includes(pk)) {
          let filtered_trades = this.trades.filter(
            (item) => item.security == pk
          );
          var indexes = [];
          for (const itm of filtered_trades) {
            let ind = this.trades.findIndex((item) => item.id == itm.id);
            if (ind >= 0) {
              indexes.push(ind);
            }
          }
          for (const index of indexes) {
            // let index = this.trades.findIndex((item) => item.security == pk);
            let cal_figure = this.helper.caculate_figures(
              this.trades[index],
              fields
            );
            this.trades[index].live_price = fields.live_price.toFixed(2);
            this.trades[index].price_up_down = cal_figure.up_down;
            this.trades[index].profit_percent = cal_figure.profit_percent;
            this.trades[index].pl_data = cal_figure.pl_price;
            this.trades[index].pl_percent = cal_figure.pl_percent;
            let ref = [...this.$refs[`${this.trades[index].id}`]];
            //     // ref[0].trade_data = data;
            ref[0].trade_data.live_price = fields.live_price.toFixed(2);
            ref[0].trade_data.price_up_down = cal_figure.up_down;
            ref[0].trade_data.profit_percent = cal_figure.profit_percent;
            ref[0].trade_data.pl_data = cal_figure.pl_price;
            ref[0].trade_data.pl_percent = cal_figure.pl_percent;
            // console.log(
            //   this.trades[index].security_name,
            //   fields.live_price,
            //   "figures"
            // );
            // ref[0].trade_data.target_price = data.target_price;
            // ref[0].trade_data.stop_loss = data.stop_loss;
          }
        }
      };
      this.socket.onclose = (error) => {
        console.log(error, "WebSocket connection closed.");
      };
    },
    // initializeWebSocket() {
    //   // const socketUrl = "ws://localhost:8001/ws/security/";
    //   const socketUrl = `${process.env.VUE_APP_WEBSOCKET_BASE_URL}trade/`;

    //   this.socket = new WebSocket(socketUrl);

    //   this.socket.onopen = () => {
    //     console.log("WebSocket connection established.");
    //     const data = {
    //       type: "trade",
    //       id: this.trade_ids,
    //     };
    //     console.log(data, "data", this.security_ids);
    //     this.socket.send(JSON.stringify(data));
    //   };

    //   this.socket.onmessage = (event) => {
    //     const data = JSON.parse(event.data);
    //     console.log(data, data.security_name, data.live_price, "on message");
    //     // if (Object.keys(fields).length !== 0) {
    //     //   this.security.live_price = fields.live_price;
    //     // }

    //     let index = this.trades.findIndex((itm) => itm.id == data.id);
    //     // this.trades[index] = data;
    //     //trade update
    //     this.trades[index]["live_price"] = data.live_price;
    //     this.trades[index]["price_up_down"] = data.price_up_down;
    //     this.trades[index]["profit_percent"] = data.profit_percent;
    //     this.trades[index]["pl_data"] = data.pl_data;
    //     this.trades[index]["pl_percent"] = data.pl_percent;
    //     this.trades[index]["target_price"] = data.target_price;
    //     this.trades[index]["stop_loss"] = data.stop_loss;

    //     //trade card update
    //     let ref = [...this.$refs[`${data.id}`]];
    //     // ref[0].trade_data = data;
    //     ref[0].trade_data.live_price = data.live_price;
    //     ref[0].trade_data.price_up_down = data.price_up_down;
    //     ref[0].trade_data.profit_percent = data.profit_percent;
    //     ref[0].trade_data.pl_data = data.pl_data;
    //     ref[0].trade_data.pl_percent = data.pl_percent;
    //     ref[0].trade_data.target_price = data.target_price;
    //     ref[0].trade_data.stop_loss = data.stop_loss;
    //   };

    //   this.socket.onclose = (error) => {
    //     console.log(error, "WebSocket connection closed.");
    //   };
    // },
    closeWebSocket() {
      if (this.socket) {
        this.socket.close();
      }
    },
    getDurationList() {
      const onSuccess = (res) => {
        var tempList = [];
        for (const obj of res.data) {
          if (obj.name_to_show !== "Short term") {
            tempList.push(obj);
          }
        }

        this.durationItems = tempList;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_DURATION_LIST, {
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
  },
  beforeDestroy() {
    this.closeWebSocket();
  },
  mounted() {
    // this.initializeWebSocket();
    this.getDurationList();
    this.tradesLoading = true;
    this.getTradesList();
    this.$store.dispatch("Auth/getNotifications");
    this.profilesLoading = true;
    this.getInfluencersList();
    this.isSuperUser();
    this.getUserDetail();
    // if (isAuthenticated()) {
    //   this.$store.state.Auth.isPrivate = true;
    //   this.$store.state.Auth.checkStatus = "HOME";
    // } else {
    //   this.$store.state.Auth.checkStatus = "LOGIN";
    //   this.$router.push({ name: "AuthPage" });
    // }
    this.$logEvent("home_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_home_view");
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";
.fullscreen {
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .scrollable {
    max-height: 100vh;
    overflow-y: auto;
  }

  .child-1 {
    max-width: 65%;
  }
}

.main-container {
  min-height: calc(100vh - 64px);
  overflow-y: hidden;
  background-color: #f6f7fa;
}

.sort-select {
  border: 1px solid rgba(51, 51, 51, 0.16) !important;
  width: 10px;
  height: 30px;
}
p {
  font-weight: 800;
  font-size: 18px;
}
.child-2 {
  background-color: #f6f7fa !important;
  border-left: 1px solid #d9d7d7;
  max-width: 450px;
  flex-grow: 1;
}
.selectBox {
  margin-right: 5px;
  width: 100%;
  height: 55px !important;
}
.add-trade-button {
  text-transform: capitalize;
  letter-spacing: 0px;
  color: white;
}
.floatingIcon {
  display: none;
}
.view-all-groups {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: center;
  color: #2d8cff;
  cursor: pointer;
}

@media all and (max-width: 600px) {
  .add-trade-button {
    display: none;
  }
  .floatingIcon {
    display: inline-flex !important;
  }
  .sort-and-filter {
    text-align: center !important;
  }
}
</style>
